import "./CatalogsScreen1.css";
import globalStates from '../../utils/global';
import { useContext, useEffect, useMemo, useState } from "react";
import { AppNavbar } from "../../components";
import { ButtonClose, productBlackCumin, productBlackPepper, productBlackPepperPowder, productChiliFlakes, productChiliPowder, productCinnamonPowder, productCinnamonStick, productCloves, productDryChilli, productMahogany, productNutmeg, productNutmegPapua, productOregano, productSesame, productTurmericPowder, productWhiteCardamom, productWhitePepper } from "../../assets";
import { 
    cssProductDialogWrapperRight,
    cssProductDialogWrapperLeft,
    cssProductDialogContainer,
    cssProductDialogWrapper,
    cssProductDialogDescription,
    cssProductDialogFrame,
    cssProductDialogFrameImg,
    cssDialogButtonClose,
    cssDialogButtonCloseImg,
    cssProductDialogTextWrapper
} from "./styles";


const CatalogsScreen1 = () =>{
    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    const defaultLanguage = globalContext && globalContext.defaultLanguage;

    const productListEn:any = useMemo(()=>{
        return [
        {
            name: "Black Pepper",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 13%", "Piperine ≥ 4%", "Bold peppercorns", "Origin: Lampung.", "Uses: Universal seasoning, spice blends, sauces, processed foods."],
            imgSrc: productBlackPepper
        },
        {
            name: "Chili Flakes",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Capsaicin 30,000-90,000 SHU", "Moisture < 10%", "Mesh 40-60", "Origin: Java.", "Uses: Sauces, seasoning blends, snacks, instant noodles, food industry."],
            imgSrc: productChiliFlakes
        },
        {
            name: "Cinnamon Stick",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 14%", "Oil content ≥ 2%", "Length ±10 cm,", "Origin: West Sumatra & Java.", "Uses: Bakery"], 
            imgSrc: productCinnamonStick
        },
        {
            name: "Cloves",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 13%", "Oil content ≥ 12%", "Purity ≥ 98%", "Origin: North Maluku.", "Uses: Sauces, bakery, beverages, pharmaceuticals, essential oil extraction."], 
            imgSrc: productCloves
        },
        {
            name: "Dry Chilli",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Capsaicin 30,000-90,000 SHU", "Moisture < 10%", "Mesh 40-60", "Origin: Java.", "Uses: Sauces, seasoning blends, snacks, instant noodles, food industry."],
            imgSrc: productDryChilli
        },
        {
            name: "Mahogany",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Purity ≥ 95%", "Origin: Java.", "Uses: Herbal remedies, traditional medicine (bitter tonic)."], 
            imgSrc: productMahogany
        },
        {
            name: "Nutmeg",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productNutmeg
        },
        {
            name: "Nutmeg Papua",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productNutmegPapua
        },
        {
            name: "White Cardamom",
            type: ["whole"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Purity ≥ 95%", "Naturally dried pods", "Origin: Java.", "Uses: Bakery, confectionery, teas, herbal, medicine, spice blends."], 
            imgSrc: productWhiteCardamom
        },
        {
            name: "White Pepper",
            type: ["whole/utuh"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 13%", "Piperine ≥ 4%", "Clean white peppercorns", "Origin: Bangka Belitung.", "Uses: Light-colored sauces, soups, seasoning mixes, Asian cuisine."], 
            imgSrc: productWhitePepper
        },
        {
            name: "Black Pepper (Powder)",
            type: ["powder/bubuk"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["Moisture < 12%", "Piperine ≥ 4%", "Mesh 40-60", "Origin: Lampung", "Uses: Instant seasoning, spice blends, processed foods, sauces."],
            imgSrc: productBlackPepperPowder
        },
        {
            name: "Cinnamon (Powder)",
            type: ["powder/bubuk"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["Moisture < 12%", "Oil content ≥ 2%", "Mesh 60-80", "Origin: West Sumatra.", "Uses: Bakery, desserts, drinks, seasoning blends, nutraceuticals."],
            imgSrc: productCinnamonPowder
        },
        {
            name: "Chili (Powder)",
            type: ["powder/bubuk"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["Capsaicin 30,000-90,000 SHU", "Moisture < 10%", "Mesh 40-60", "Origin: Java.", "Uses: Sauces, seasoning blends, snacks, instant noodles, food industry."],
            imgSrc: productChiliPowder
        },
        {
            name: "Tumeric (Powder)",
            type: ["powder/bubuk"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["Curcumin > 5%", "Moisture < 12 %", "Bright yellow", "Mesh 60-80", "Origin: Java & Sumatra", "Uses: Curry Powder, spice blends, beverages, herbal medicine, natural food coloring."],
            imgSrc: productTurmericPowder
        },
        {
            name: "Black Cumin (Seed)",
            type: ["seed/biji"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "seeds",
            description: ["Moisture < 10%", "Purity ≥ 98%", "Origin: Java.", "Uses: Herbal medicine, functional foods, immune-boosting supplements"], 
            imgSrc: productBlackCumin
        },
        {
            name: "Oregano (Seed)",
            type: ["seed/biji"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "seeds",
            description: ["Moisture < 10%", "Purity ≥ 95%", "Origin: Cultivated in Indonesia.", "Uses: Culinary seasoning, herbal teas, cultivation."], 
            imgSrc: productOregano
        },
        {
            name: "Sesame (Seed)",
            type: ["seed/biji"],
            size: "250 grams or per request",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "seeds",
            description: ["White/Brown", "Moisture < 8%", "Purity ≥ 99%", "Oil content ≥ 48%", "Origin: Nusa tenggara.", "Uses: Bakery, confectionery, tahini, sesame oil extraction."], 
            imgSrc: productSesame
        },

    ]
    }, []) 
    const productListIna:any = useMemo(()=>{
        return [
        {
            name: "Black Pepper",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."],
            imgSrc: productBlackPepper
        },
        {
            name: "Chili Flakes",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."],
            imgSrc: productChiliFlakes
        },
        {
            name: "Cinnamon Stick",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productCinnamonStick
        },
        {
            name: "Dry Chilli",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole", 
            imgSrc: productDryChilli
        },
        {
            name: "Cloves",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole", 
            imgSrc: productCloves
        },
        {
            name: "Mahogany",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole", 
            imgSrc: productMahogany
        },
        {
            name: "Nutmeg",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productNutmeg
        },
        {
            name: "Nutmeg Papua",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productNutmegPapua
        },
        {
            name: "White Cardamom",
            type: ["whole"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productWhiteCardamom
        },
        {
            name: "White Pepper",
            type: ["whole/utuh"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "whole",
            description: ["Moisture < 12%", "Oil content 8–10%", "Purity ≥ 98%", "Origin: Papua & Maluku.", "Uses: Bakery, confectionery, beverages, essential oils, herbal remedies."], 
            imgSrc: productWhitePepper
        },
        {
            name: "Black Pepper (Powder)",
            type: ["powder/bubuk"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["lorem ipsum"],
            imgSrc: productBlackPepperPowder
        },
        {
            name: "Cinnamon (Powder)",
            type: ["powder/bubuk"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["lorem ipsum"],
            imgSrc: productCinnamonPowder
        },
         {
            name: "Chili (Powder)",
            type: ["powder/bubuk"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["lorem ipsum"],
            imgSrc: productChiliPowder
        },
        {
            name: "Tumeric (Powder)",
            type: ["powder/bubuk"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "powder", 
            description: ["lorem ipsum"],
            imgSrc: productTurmericPowder
        },
        {
            name: "Black Cumin (Seed)",
            type: ["seed/biji"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "seeds",
            description: ["lorem ipsum"], 
            imgSrc: productBlackCumin
        },
        {
            name: "Oregano (Seed)",
            type: ["seed/biji"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "seeds",
            description: ["lorem ipsum"], 
            imgSrc: productOregano
        },
        {
            name: "Sesame (Seed)",
            type: ["seed/biji"],
            size: "250 gram atau sesuai permintaan",
            packaging: ["Retail - Bulk Export", "️250grm standing pouch - 50 kg Jumbo PP Bags", "️Request Customized Label"],
            notes: "seeds",
            description: ["lorem ipsum"], 
            imgSrc: productSesame
        },
    ]
    }, [])

    const [productList, setProductList] = useState(productListEn);
    const [selectedProduct, setSelectedProduct] = useState(null) as any;

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredProducts, setFilteredProducts] = useState(productList);
    const handleSearch = (event:any) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        const filtered = productList.filter((product:any) => 
        product.name.toLowerCase().includes(term) ||
        product.type.some((type:any) => type.toLowerCase().includes(term)) ||
        product.size.toLowerCase().includes(term) ||
        product.packaging.toLowerCase().includes(term) ||
        product.notes.toLowerCase().includes(term)
        );

        setFilteredProducts(filtered);
    };

    const handleFilter= (filterValue:string) => {
        const term = filterValue || "";

        const filtered = productList.filter((product:any) => 
            product.type.some((type:any) => type.toLowerCase().includes(term)) 
        );

        setFilteredProducts(filtered);
    };

    const handleDialogCloseButton=()=>{
        setSelectedProduct(null)
    };

    useEffect(()=>{
        if(defaultLanguage==="en"){
            setProductList(productListEn)
        } else {
            setProductList(productListIna)
        }
        setTimeout(()=>{
            return setFilteredProducts(productList);
        }, 0)
    }, [defaultLanguage, productListEn, productListIna, productList])


    return(
        <>
        <div className={`${windowWidthClass}-catalogs-screen-1`}>
            <AppNavbar additional={{navClass: "navbar-additional"}}/>
            <div className="screen-wrapper">
                <div className="wrapper-searchbar">
                    <h2>Product Catalogs</h2>
                    <input 
                    type="text" 
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="search here"/>
                    <div className="searchbar-menu">
                        <p className="linebar"
                            onClick={()=>handleFilter('')}
                        >all products</p>
                        <p className="linebar"
                            onClick={()=>handleFilter('whole')}
                        >whole</p>
                        <p className="linebar"
                            onClick={()=>handleFilter('powder')}
                        >powder</p>
                        <p
                            onClick={()=>handleFilter('seed')}
                        >seeds</p>
                    </div>
                </div>
                <div className="wrapper-cardbox">
                    {
                        filteredProducts.map((product:any, index:any)=>{
                           
                            const hanldeDialogPD = ()=>{
                                setSelectedProduct(product)
                            }

                            const {name, notes, size, packaging, imgSrc} = product;
                            return(
                                <div key={name+index} className="grid-item" onClick={hanldeDialogPD} >
                                    <div className="card-product">
                                        <div className="card-wrapper-image">
                                            <img src={imgSrc} alt={name}/>
                                        </div>
                                        <div className="card-wrapper-details">
                                            <p className="card-name">{name}</p>
                                            <p className="notes"><b>available stock:</b> {notes}</p>
                                            {/* <p className="size"><b>size:</b> {size}</p> */}
                                            <p className="packaging"><b>packaging:</b> {packaging}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
        :
        {
        selectedProduct&&
            <div className={"product-dialog-container"} style={cssProductDialogContainer[windowWidthClass]}>
                <div className="product-dialog-wrapper" style={cssProductDialogWrapper[windowWidthClass]}>
                    <div className="dialog-wrapper-left" style={cssProductDialogWrapperLeft[windowWidthClass]}>
                        {(windowWidthClass==="w-mob")?<div className="product-dialog-description-button-close" style={cssDialogButtonClose[windowWidthClass]} 
                            onClick={handleDialogCloseButton}>
                                <img src={ButtonClose} alt="close-button" style={cssDialogButtonCloseImg[windowWidthClass]} />
                        </div>:<></>}
                        <div className="product-dialog-frame" style={cssProductDialogFrame[windowWidthClass]}>
                            <img src={selectedProduct["imgSrc"]} alt={selectedProduct["name"]} style={cssProductDialogFrameImg[windowWidthClass]}/>
                        </div>
                    </div>
                    <div className="dialog-wrapper-right" style={cssProductDialogWrapperRight[windowWidthClass]}>
                        <div className={windowWidthClass+"-product-dialog-description"} style={cssProductDialogDescription[windowWidthClass]}>
                            {(windowWidthClass==="w-mob")?<></>:<div className="product-dialog-description-button-close" style={cssDialogButtonClose[windowWidthClass]} 
                            onClick={handleDialogCloseButton}>
                                <img src={ButtonClose} alt="close-button" style={cssDialogButtonCloseImg[windowWidthClass]} />
                            </div>}
                            <p className="card-name"><b>product:</b> {selectedProduct["name"]}</p>
                            <p className="notes"><b>available stock:</b> {selectedProduct["notes"]}</p>
                            {/* <p className="size"><b>size:</b> {selectedProduct["size"]}</p> */}
                            <div className="product-dialog-text-wrapper" style={cssProductDialogTextWrapper[windowWidthClass]}>
                                <p className="text-wrapper-title packaging"><b>packaging:</b></p>
                                {selectedProduct["packaging"].map((packagingDetail:any, index:any)=>{
                                    return <p className="text packaging">✅️ {packagingDetail}</p>
                                })
                                }
                            </div>
                            <div className="product-dialog-text-wrapper" style={cssProductDialogTextWrapper[windowWidthClass]}>
                                <p className="text-wrapper-title packaging"><b>description:</b></p>
                                {selectedProduct["description"].map((descriptionDetail:any, index:any)=>{
                                    return <p className="text description">✅️ {descriptionDetail}</p>
                                })
                                }
                            </div>
                        </div>
                         
                    </div>

                </div>
               
            </div>
        }
        </>
    )
};

export default CatalogsScreen1;

